import React, { useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";


const TwoFactorVerify = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const stateUserId = location.state?.userId || "";
    const stateEmail = location.state?.email || "";

    const queryUserId = searchParams.get("userId") || "";
    const queryEmail = searchParams.get("email") || "";

    const userId = useMemo(() => stateUserId || queryUserId, [stateUserId, queryUserId]);
    const email = useMemo(() => stateEmail || queryEmail, [stateEmail, queryEmail]);

    const [token, setToken] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");
    const [status, setStatus] = useState("");

    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        setStatus("");

        try {
            const res = await fetch("/api/2fa/verify-login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userId,
                    token: token.trim(),
                }),
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.message || "Two-factor verification failed.");
                return;
            }

            login({
                user: data.user,
                token: data.token
            });

            navigate("/", { replace: true });

        } catch (err) {
            console.error("2FA verification error:", err);
            setError("Server error.");
        } finally {
            setSubmitting(false);
        }
    };

    if (!userId) {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "grid",
                    placeItems: "center",
                    background: "var(--background, #f7f7fb)",
                    padding: 24,
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: 460,
                        background: "var(--card-bg, #fff)",
                        border: "1px solid var(--border, #e5e7eb)",
                        borderRadius: 20,
                        padding: 28,
                        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    }}
                >
                    <h1 style={{ margin: "0 0 12px", fontSize: "1.5rem" }}>
                        Two-Factor Verification
                    </h1>
                    <p style={{ color: "crimson", marginBottom: 18 }}>
                        Missing verification session. Please log in again.
                    </p>
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        );
    }

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                background: "var(--background, #f7f7fb)",
                padding: 24,
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: 460,
                    background: "var(--card-bg, #fff)",
                    border: "1px solid var(--border, #e5e7eb)",
                    borderRadius: 20,
                    padding: 28,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                }}
            >
                <h1 style={{ margin: "0 0 10px", fontSize: "1.6rem" }}>
                    Two-Factor Verification
                </h1>

                <p style={{ margin: "0 0 20px", color: "var(--muted, #666)" }}>
                    Enter the code from your authenticator app
                    {email ? ` for ${email}` : ""}.
                </p>

                <form onSubmit={handleSubmit} style={{ display: "grid", gap: 14 }}>
                    <label style={{ display: "grid", gap: 8 }}>
                        <span>Authentication Code</span>
                        <input
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            placeholder="Enter 6-digit code"
                            required
                            value={token}
                            onChange={(e) => setToken(e.target.value)}
                            style={{
                                padding: "12px 14px",
                                borderRadius: 12,
                                border: "1px solid var(--border, #d1d5db)",
                                outline: "none",
                            }}
                        />
                    </label>

                    <button
                        type="submit"
                        disabled={submitting}
                        style={{
                            padding: "12px 16px",
                            borderRadius: 12,
                            border: "none",
                            cursor: submitting ? "not-allowed" : "pointer",
                            background: "var(--accent-color, #5A3EBA)",
                            color: "#fff",
                            fontWeight: 700,
                            opacity: submitting ? 0.7 : 1,
                        }}
                    >
                        {submitting ? "Verifying..." : "Verify Code"}
                    </button>
                </form>

                {status ? (
                    <p style={{ marginTop: 16, color: "green" }}>{status}</p>
                ) : null}

                {error ? (
                    <p style={{ marginTop: 16, color: "crimson" }}>{error}</p>
                ) : null}

                <div style={{ marginTop: 20 }}>
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default TwoFactorVerify;